import React from "react";
import { useLoginSession } from "../LoginSession";

function Brand({ style = {} }) {
    const loginSession = useLoginSession(false);
    const orgInfo = loginSession.orgInfo;

    const src = orgInfo?.custom_brand ? "data:image/png;charset=utf-8;base64," + orgInfo.custom_brand : "";

    const defaultStyle = {
        maxWidth: "320px",
        margin: "auto",
        padding: "24px",
    };

    return <img src={src} alt={orgInfo?.name} style={{ ...defaultStyle, ...style }} />;
}

export default Brand;
